"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["date", "dateStyle", "timeStyle", "locale", "utc", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function inputFormat(date, utc) {
  if (utc === void 0) {
    utc = true;
  }
  // Return null if date formate is invalidate format
  if (date && isNaN(new Date(date).valueOf())) {
    return null;
  }

  // Data with timestamp
  if (date && typeof date === 'number' && new Date(date).valueOf() > 0) {
    // UNIX timestamp in seconds
    if (date.toString().length <= 10) {
      return date * 1000;
    }
    // JavaScript timestamp in milliseconds
    return date;
  }

  // Data with string
  if (date && new Date(date) instanceof Date) {
    return utc ? date + ' UTC' : date;
  }
  return null;
}
function outputFormat(date, locale, dateStyle, timeStyle) {
  if (date) {
    // If both styles, date and time, are hidden return date only
    var style = {};

    // both date and time
    if (dateStyle !== 'hide' && timeStyle !== 'hide') {
      style = {
        dateStyle: dateStyle,
        timeStyle: timeStyle
      };
    }
    // date only
    else if (dateStyle !== 'hide' && timeStyle === 'hide') {
      style = {
        dateStyle: dateStyle
      };
    }
    // time only
    else if (dateStyle === 'hide' && timeStyle !== 'hide') {
      style = {
        timeStyle: timeStyle
      };
    }
    var o = new Intl.DateTimeFormat(locale.split('_').join('-'), style);
    var d = new Date(date);
    return o.format(d);
  }
  return null;
}
var DateOutput = function DateOutput(_ref) {
  var propDate = _ref.date,
    dateStyle = _ref.dateStyle,
    timeStyle = _ref.timeStyle,
    locale = _ref.locale,
    utc = _ref.utc,
    className = _ref.className,
    attributes = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _React$useState = _react.default.useState(null),
    output = _React$useState[0],
    setOutput = _React$useState[1];
  var classes = (0, _clsx.default)('uk-date', className);
  _react.default.useEffect(function () {
    if (propDate) {
      var isValidDate = inputFormat(propDate, utc);
      if (isValidDate) {
        var date = new Date(isValidDate);
        setOutput(outputFormat(date, locale, dateStyle, timeStyle));
      } else {
        setOutput(null);
      }
    }
  }, [propDate, locale, dateStyle, timeStyle, utc]);
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: classes
  }, attributes), output);
};
DateOutput.propTypes = {
  /**
   * Take any dates
   */
  date: _propTypes.default.any.isRequired,
  /**
   * Formatting date style to be display
   */
  dateStyle: _propTypes.default.oneOf(['full', 'long', 'medium', 'short', 'hide']),
  /**
   * Formatting time style to be display
   */
  timeStyle: _propTypes.default.oneOf(['full', 'long', 'medium', 'short', 'hide']),
  /**
   * Format date according to the locale
   */
  locale: _propTypes.default.oneOf(['en', 'en_CA', 'en-CA', 'fr', 'fr_CA', 'fr-CA']),
  /**
   * To set the date according to the user's timezone, this flag indicate if the date is in UTC
   */
  utc: _propTypes.default.bool
};
DateOutput.defaultProps = {
  date: '20 09 2006,12:52:39',
  locale: 'en',
  dateStyle: 'medium',
  timeStyle: 'hide',
  utc: true
};
var _default = exports.default = DateOutput;